import { Stack } from "@mui/material";
import IconComponent from "../components/ui/IconComponent";

interface Props {
  base: string;
  quote: string;
  size?: number;
}

const PairInfo = ({ base, quote, size }: Props) => {
  return (
    <Stack direction="row" sx={{ position: "relative" }}>
      <IconComponent
        style={{ position: "relative", zIndex: 1 }}
        iconName={`${base}`}
        type="asBackground"
        size={size ?? 28}
      />
      <IconComponent
        style={{ position: "relative", left: -4 }}
        iconName={quote}
        size={size ?? 28}
        type="asBackground"
      />
    </Stack>
  );
};

export default PairInfo;
